import { Component, ChangeDetectionStrategy, input, inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { produce } from 'immer';
import { SidebarPlaceholderComponent } from 'libs/shared/ui-common/src/lib/components/sidebar-placeholder/sidebar-placeholder.component';
import { GuidelineService } from 'shared/domain';
import {
  ButtonDirective,
  ConfirmationDialogArgs,
  ConfirmationDialogComponent,
  DialogService,
  IconDirective,
  KeyValueComponent,
} from 'shared/ui-common';
import { isTruthy } from 'shared/util-common';

import { WorkflowWidget } from '@treetop/shared/model';

@Component({
  standalone: true,
  imports: [
    MatTabsModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    TranslocoModule,
    SidebarPlaceholderComponent,
    MatFormFieldModule,
    MatIconModule,
    IconDirective,
    TranslocoModule,
    KeyValueComponent,
    ButtonDirective,
  ],
  selector: 'tt-guideline-workflow-sidebar-wrapper',
  templateUrl: './workflow-sidebar-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./workflow-sidebar-wrapper.component.scss'],
})
export class WorkflowSidebarWrapperComponent {
  private guidelineService = inject(GuidelineService);
  private dialogService = inject(DialogService);

  protected widget = input.required<WorkflowWidget>();

  protected resetWorkflowWidget() {
    const args: ConfirmationDialogArgs = {
      message: 'WorkflowWidget.RemoveConfirmationDialog.Message',
      cancelButtonCaption: 'Cancel',
      confirmButtonCaption: 'WorkflowWidget.RemoveWorkflow',
      buttonVariant: 'destructive',
    };

    const dialog = this.dialogService.open(ConfirmationDialogComponent, {
      title: 'WorkflowWidget.RemoveConfirmationDialog.Title',
      data: args,
    });

    dialog
      .afterClosed()
      .pipe(isTruthy())
      .subscribe(() => {
        const updatedWorkflow = produce(this.widget(), (draft) => {
          draft.workflowId = undefined;
          draft.workflowVersion = undefined;
          draft.workflowTitle = undefined;
          draft.latestVersion = undefined;
          draft.isOutdated = undefined;
        });
        this.guidelineService.updateWidget(this.widget().uniqueId, updatedWorkflow);
      });
  }
}
